import React, { ChangeEvent } from 'react';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { CouponCodeAttributes, CouponCodeType } from '@api/graphql/types';
import FormRow from '@components/Form/FormRow';
import Input from '@components/Form/Input';

interface Props {
    name: string;
    value: CouponCodeAttributes | null;
    onChange: (value: CouponCodeAttributes | null, name: string) => void;
}

class CouponCodeAttributesForm extends React.Component<Props & InjectedIntlProps> {
    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.coupon.coupon_code_attributes.${id}` });
    }

    private onChange = (val: any, name: keyof CouponCodeAttributes) => {
        if (this.props.value) {
            const value = {...this.props.value, [name]: val};
            this.props.onChange(value, this.props.name);
        }
    }

    private renderForm = () => {
        if (!this.props.value) {
            return '';
        }

        return (
            <>
                <FormRow label={this.label('count.title')}>
                    <Input type="number" name="count" value={this.props.value.count} onChange={this.onChange} />
                </FormRow>

                <FormRow label={this.label('length.title')}>
                    <Input type="number" name="length" value={this.props.value.length || 0} onChange={this.onChange} />
                </FormRow>

                <FormRow label={this.label('type.title')}>
                    <select className="form-control" name="type" onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                        this.onChange(e.currentTarget.value, 'type');
                    }}>
                        <option value="">---</option>
                        {Object.keys(CouponCodeType).map((key) => (
                            <option key={key} value={CouponCodeType[key]}>{this.props.intl.formatMessage({id: `module.coupon.CouponCodeType.${key}`})}</option>
                        ))}
                    </select>
                </FormRow>

                <FormRow label={this.label('prefix.title')}>
                    <Input type="text" name="prefix" value={this.props.value.prefix || ''} onChange={this.onChange} />
                </FormRow>

                <FormRow label={this.label('suffix.title')}>
                    <Input type="text" name="suffix" value={this.props.value.suffix || ''} onChange={this.onChange} />
                </FormRow>
            </>
        );
    }

    public render() {
        return (
            <>
                {this.renderForm()}
            </>
        );
    }
}

export default compose(
    injectIntl,
)(CouponCodeAttributesForm);



// WEBPACK FOOTER //
// ./src/modules/Coupon/components/CouponCodeAttributesForm.tsx